import bizNodeModel from '../../bizNodeModel.mjs'
import RuleType from './RuleType.jsx'

export default bizNodeModel({
    ruleKey: {
        name: () => '规则关键字',
    },

    ruleTitle: {
        name: () => '规则标题',
        required: () => true,
    },

    ruleType: {
        name: () => '规则类型',

        readableValue: (map, node) => {
            const {ruleType} = node.data

            if (ruleType) {
                const match = RuleType.find(e => ruleType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    ruleUserCode: {
        name: () => '规则代码',
    },

    resume: {
        name: () => '简述',
    },
})
